import { Component } from "react";
import PropTypes from "prop-types";
import { accessToken } from "../../accessToken";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import * as MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

class Geocoder extends Component {
  static contextTypes = { map: PropTypes.object.isRequired };

  componentDidMount() {
    const { map } = this.context;
    map.addControl(
      new MapboxGeocoder({
        accessToken,
        placeholder: "Zoeken"
      })
    );
  }

  render() {
    return null;
  }
}

export default Geocoder;



// WEBPACK FOOTER //
// ./src/NewRoute/components/Geocoder.js